<template>
    <div class="card-input-c2p">
        <div class="card-input-brand" v-if="cardBrand">
            <CardBrand data-dd-privacy="mask" :brand="cardBrand" tabindex="-1" />
        </div>
        <CieloInput
            class="m-0"
            :autofocus="true"
            :borderless="false"
            name="CreditCardNumber"
            :label="$ml.get('cardNumber')"
            @input="(value) => $emit('input', value)"
            :value="cardNumber"
            v-validate="'required|numeric|min:12|max:19|luhn-chk'"
            :data-vv-as="$ml.get('cardNumber')"
            :error="errors.first('CreditCardNumber') || errorCard"
            type="tel"
            :mask="['#### #### #### #### #####']"
            :autocomplete="'off'"
        />
    </div>
</template>

<script>
const CieloInput = () =>
	import(
		/* webpackChunkName: "cielo-input" */
		'@/components/template/CieloInput'
	);
import LuhnAlgorithm from '@/helpers/validation-rules/LuhnAlgorithm';
import CardBrand from '@/components/CardBrand';

export default {
	components: {
		CardBrand,
		CieloInput,
	},

	mounted() {
		this.$validator.extend('luhn-chk', LuhnAlgorithm);
	},

	watch: {
		isValidErrors() {
			this.$validator.validate();
		},
	},

	props: {
		cardNumber: {
			type: String,
			default: '',
		},
		cardBrand: {
			type: String,
			default: '',
		},
		errorCard: {
			type: String,
			default: '',
		},
		isValidErrors: {
			type: Boolean,
		}
	},
};
</script>

<style lang="css" scoped>
.card-input-c2p {
	position: relative;
	width: 100%;
}

.card-input-brand {
	position: absolute;
	top: 16px;
	right: 16px;
	width: 36px;
	height: 23px;
	border-radius: 4px;
	z-index: 2;
}
</style>
